module.exports = __webpack_public_path__ + "img/logo-fitpay.jpg";